import { VueExtension } from '../../utils/extensions/vue';
import Badge from './badge.jsx';
import './badge.scss';

VueExtension.WithInstall(Badge);

export default Badge;
